import { CheckIcon } from './Icons.jsx';
import CorrectnessTally from './CorrectnessTally.jsx';
import './ExprQuestion.css';

/**
 * Projector view of an expr question. While students are answering it shows
 * the expressions with empty blanks and nothing else — showing the running
 * distribution would tell whoever hasn't answered yet what the room thinks.
 * On reveal the correct operator drops into each blank and a chip row under
 * it shows what the room actually picked, which is where the teacher sees
 * how many students swapped // and %.
 */
export default function HostExprPreview({ payload, revealed, tally }) {
  const items = payload.items || [];
  const slotCounts = new Map((tally?.items || []).map((row) => [row.id, row.counts || {}]));

  return (
    <div className="stack host-expr-stack">
      <div className="expr-list">
        {items.map((item) => {
          const counts = slotCounts.get(item.id) || {};
          const picks = Object.entries(counts).sort((a, b) => b[1] - a[1]);
          return (
            <div key={item.id} className={`expr-row host-expr-row ${revealed ? 'is-correct' : ''}`}>
              <span className="expr-line num">
                <span className="expr-operand">{item.left}</span>
                <span className={`expr-blank ${revealed ? 'is-filled' : ''}`}>
                  {revealed ? item.answer : '?'}
                </span>
                <span className="expr-operand">{item.right}</span>
                <span className="expr-eq">=</span>
                <span className="expr-target">{item.target}</span>
              </span>

              {revealed && item.note && <span className="expr-note">{item.note}</span>}

              {revealed && picks.length > 0 && (
                <div className="expr-dist">
                  {picks.map(([op, count]) => (
                    <span key={op} className={`expr-dist-chip ${op === item.answer ? 'is-answer' : ''}`}>
                      <span className="num">{op}</span>
                      <span className="expr-dist-count">{count} คน</span>
                    </span>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {revealed && payload.revealNote && (
        <p className="expr-success text-center row" style={{ justifyContent: 'center', gap: '6px' }}>
          <CheckIcon size={18} />
          <span>{payload.revealNote}</span>
        </p>
      )}

      {revealed && <CorrectnessTally tally={tally} />}
    </div>
  );
}
